import React, { Fragment } from "react";
import Sticky from "react-stickynode";
import { ThemeProvider } from "styled-components";
import { interiorTheme } from "common/theme/interior";
import { DrawerProvider } from "common/contexts/DrawerContext";
import Navbar from "containers/Interior/Navbar";
import Footer from "containers/Interior/Footer";
import Heading from "common/components/Heading";
import { ResetCSS } from "common/assets/css/style";
import {
  GlobalStyle,
  InteriorWrapper,
  ContentWrapper,
  BodyWrapper,
} from "containers/Interior/interior.style";
import SEO from "components/seo";

export default () => {
  return (
    <ThemeProvider theme={interiorTheme}>
      <Fragment>
        <SEO title="Terms and conditions" />
        <ResetCSS />
        <GlobalStyle />

        {/* Start writing your markup from here. */}
        <InteriorWrapper>
          <Sticky top={0} innerZ={9999} activeClass="sticky-nav-active">
            <DrawerProvider>
              <Navbar />
            </DrawerProvider>
          </Sticky>
          <ContentWrapper>
            <BodyWrapper>
              <Heading as="h1" content="Terms and conditions" />

              <p>
                <strong>Last Revised Date: September 10, 2019 &nbsp;</strong>
              </p>

              <p>
                Welcome to the website of Direct4.me and its affiliates
                (collectively, “Direct4.me”) and Direct4.me’s other online
                locations such as Facebook, Twitter, YouTube etc. (the
                “Websites”, and each a “Website”), operated exclusively in
                Slovenia and Croatia by:
              </p>

              <p>
                <strong>Kivi Com, d.o.o.</strong>
              </p>

              <p>Kidričeva 3A,&nbsp;</p>

              <p>2380 Slovenj Gradec,&nbsp;</p>

              <p>Slovenia &nbsp;</p>

              <p>
                Email:&nbsp;<a href="mailto:info@direct4.me">info@direct4.me</a>
              </p>

              <p>
                Internet: &nbsp;<a href="https://www.direct4.me">www.direct4.me</a>
              </p>

              <p>Tel: (+386) 2 88 39 400</p>

              <p>Fax: (+386) 2 88 41 119</p>

              <p>Corporate registration number 5794617</p>

              <p>VAT: SI86143735</p>

              <p>
                Direct4.me’s affiliates include without limitation the entities
                operating the Website and other entities that may be affiliated
                with Direct4.me.
              </p>

              <p>
                If you have a question whether a website is a website of
                Direct4.me, or if an entity is an affiliate of Direct4.me, Inc.
                please check the information posted on the site or contact us at{" "}
                <a href="mailto:info@direct4.me">info@direct4.me</a>
              </p>

              <p>
                User of Direct4.me websites is any person who, as a visitor,
                uses company’s website www.direct4.me&nbsp;or related websites.
              </p>

              <p>
                Direct4.me provides the Websites as a service to you subject to
                the following terms of Use (“Terms”).
              </p>

              <p>&nbsp;</p>

              <h1>ACCEPTANCE OF TERMS OF USE</h1>

              <p>
                Please carefully read the following Terms before using the
                Website. By accessing the Website, you acknowledge that you have
                read, understood and agree to be bound by these Terms which form
                an agreement that is effective as if you had signed it. If at
                any time you do not agree to these Terms, please do not access
                or use the Website.
              </p>

              <p>
                These Terms may be revised or updated from time to time.
                Accordingly, you should check the Terms regularly for updates.
                Each time you access, use or browse the Website, you signify
                your acceptance of the then-current Terms. Any changes in these
                Terms take effect upon posting and apply only to use of the
                Website and information collected from you on and after Last
                Revised date, unless we provide notice or have other
                communications with you.
              </p>

              <p>&nbsp;</p>

              <h1>AGE RESTRICTIONS</h1>

              <p>
                The Website is directed to persons 18 years of age or older. If
                you are 13-17 years of age, you may visit, browse and use the
                information on the Website, but you may not submit any personal
                information to the Website, and you represent and warrant to
                Direct4.me that you have the permission of your parent or legal
                guardian to use the Website and any activities on the Website,
                and your parent or legal guardian agrees to these Terms on your
                behalf. Any personally identifiable information submitted to the
                Website of a child under 18 years must be provided only by a
                child’s parent or legal guardian. The parent or legal guardian
                represents and warrants to Direct4.me that the information being
                provided is solely for the purpose of Direct4.m4 being able to
                conduct its business and that the parent or guardian agrees to
                these Terms on their minor child. If you are under the age of 13
                years old, you may not use the website.
              </p>

              <p>&nbsp;</p>

              <h1>PERMITTED USE OF WEBSITE</h1>

              <p>
                The content available through the Website, including without
                limitation text, graphics, logos, icons, images, media, data,
                audio, animation, videos, charts, maps, software and other
                information and materials (collectively, the “Content”) is the
                sole and exclusive property of Direct4.me and/or its licensors.
                You agree not to produce, duplicate, modify, copy, sell, resell
                or exploit for any commercial purpose, any portion of the
                Website or the Content other than as expressly authorized by
                Direct4.me in writing. Use of the Website or the Content in any
                way not expressly permitted by these Terms is prohibited, and
                may be actionable under European Union or international law. You
                agree not to access the Website by any means other than through
                a standard web browser.
              </p>

              <p>
                You may not duplicate, publish, display, modify, distribute,
                perform, reproduce, copy, sell, resell, exploit or create
                derivative works from any part of the Website or Content unless
                expressly authorized by Direct4.me in writing. You agree that
                you will not remove, obscure, or modify any acknowledgements,
                credits or legal, intellectual property or proprietary notices,
                or marks, or logos contained on the Website or in the Content.
              </p>

              <p>&nbsp;</p>

              <h1>PRIVACY POLICY</h1>

              <p>
                Please review the Privacy Policy for the Website. If you do not
                agree with the Privacy Policy, you are not authorized to use the
                Website. The terms of the Privacy Policy are governed by the EU
                Directive of General Data Protection Regulation (GDPR) and
                incorporated herein by this reference. Please refer to the
                complete Privacy Terms on our site at{" "}
                <a href="legalnotice">www.direct4.me/legalnotice</a>
              </p>

              <p>&nbsp;</p>

              <h1>RESTRICTED ACCESS</h1>

              <p>
                The Website may restrict access to the site or to sections or
                features of the site. A separate agreement that addresses access
                and use may apply to those sites, sections or features. In the
                event that you are required to select a username or password to
                access those sites, sections or features, you are responsible
                for maintaining the confidentiality of your password and are
                fully responsible for all uses of your password, whether by you
                or others. You authorize Direct4.me to act on instructions
                received through use of your password, and agree that Direct4.me
                is not liable for any loss or damage arising from your failure
                to comply with this Section. You agree to immediately notify
                Direct4.me at{" "}
                <a href="mailto:support@direct4.me">support@direct4.me</a> of
                any unauthorized use of your password or any other breach of
                security.
              </p>

              <p>&nbsp;</p>

              <h1>PROPERTY RIGHTS</h1>

              <p>
                You acknowledge and agree that, as between Direct4.me and you,
                all rights, title, and interest in and to the Website and the
                Content, including without limitation any patents, copyrights,
                trademarks, trade secrets, inventions, know-how, and all other
                intellectual property rights are owned exclusively by Direct4.me
                or its licensors, are valid and enforceable, and are protected
                by European Union intellectual property laws and other
                applicable laws.
              </p>

              <p>&nbsp;</p>

              <h1>COPYRIGHT</h1>

              <p>
                All Content included in the Website is the copyright and
                property of Direct4.me or its content suppliers and protected by
                EU and international copyright laws. Permission is granted to
                electronically copy and print hard copy portions of the Website
                for the sole purpose of using the Website as a personal or
                internal resource or otherwise for its intended purposes. Any
                other use, including the reproduction, modification,
                distribution, transmission, republication, display or
                performance, of the Content of the Website, is strictly
                prohibited.
              </p>

              <p>&nbsp;</p>

              <h1>TRADEMARKS</h1>

              <p>
                The trademarks, service marks, logos, slogans, trade names and
                trade dress used on the Website are proprietary of Direct4.me or
                its licensors. Unauthorized use of any trademark of Direct4.me
                may be a violation of EU trademark laws. Any third- party names
                or trademarks referenced in the Website do not constitute or
                imply affiliation, endorsement or recommendation by Direct4.me,
                or of Direct4.me by the third parties.
              </p>

              <p>&nbsp;</p>

              <h1>YOUR INDEMNITY OF DIRECT4.ME</h1>

              <p>
                YOU AGREE TO INDEMNIFY, DEFEND AND HOLD DIRECT4.ME, ITS
                OFFICERS, DIRECTORS, EMPLOYEES, AGENTS, SUBSIDIARIES,
                AFFILIATES, LICENSORS, SERVICE PROVIDERS AND OTHERS ACTING IN
                CONCERT WITH IT, HARMLESS FROM ANY LOSS, LIABILITY, CLAIM OR
                DEMAND, INCLUDING WITHOUT LIMITATION REASONABLE ATTORNEYS’ FEES,
                MADE BY YOU OR ON YOUR BEHALF OR BY ANY THIRD PARTY DUE TO OR
                ARISING OUT OF (A) YOUR CONNECTION OR SUBMISSION TO OR USE OF
                THE WEBSITE OR THE CONTENT; OR (B) YOUR VIOLATION OF THESE TERMS
                OF USE, ANY APPLICABLE LAWS, OR THE RIGHTS OF DIRECT4.ME OR ANY
                THIRD PARTY.
              </p>

              <p>&nbsp;</p>

              <h1>USER GENERATED CONTENT</h1>

              <p>
                <strong>Communications Services:</strong> We may have a
                Facebook, Twitter and/or YouTube or other pages and the Website
                may have blogs, chat areas, forums, comments, rankings,
                sweepstakes, contests, games, communities, calendars, and/or
                other message or communication facilities that are designed to
                enable you and others to communicate with Direct4.me and other
                users of the Website (collectively, “Communication Services”).
                You acknowledge that your submissions to the Website may be or
                become available to others. You agree only to post, send, and
                receive messages and materials that are proper and related to
                the particular Communication Service and to adhere to these
                Terms.
              </p>

              <p>
                <strong>Prohibited Actions:</strong> You agree that the
                following actions are prohibited and constitute a material
                breach of these Terms. This list is not meant to be exhaustive,
                and Direct4.me reserves the right to determine what types of
                conduct it considers to be inappropriate use of the Website. In
                the case of inappropriate use, Direct4.me or its designee may
                take such measures as it determines at its sole discretion.
              </p>

              <p>
                By way of example, and not as a limitation, you agree that when
                using a Communication Service, you will not:
              </p>

              <ol>
                <li>
                  Use the Website or the Content for any purpose or to take any
                  actions in violation of local, state, national, or
                  international laws, regulations, codes, or rules.
                </li>
                <li>
                  Violate any code of conduct or other guidelines which may be
                  applicable for any particular Communication Service.
                </li>
                <li>
                  Take any action that imposes an unreasonable or
                  disproportionately large load on the Website’s infrastructure
                  or otherwise in a manner that may adversely affect performance
                  of the Website or restrict or inhibit any other user from
                  using and enjoying the Communication Services or the Website.
                </li>
                <li>
                  Use the Website for unauthorized framing or linking, or via
                  automated devices, bots, agents, scraping, scripts,
                  intelligent search or any similar means of access to the
                  Content.
                </li>
                <li>
                  Aggregate, copy, duplicate, publish, or make available any of
                  the Content to third parties outside the Website in any
                  manner.
                </li>
                <li>
                  Defame, abuse, harass, stalk, threaten or otherwise violate
                  the legal rights (such as rights of privacy and publicity) of
                  others
                </li>
                <li>
                  Publish, post, upload, distribute or disseminate any
                  inappropriate, profane, defamatory, infringing, obscene,
                  indecent or unlawful topic, name, material, content, or
                  information.
                </li>
                <li>
                  Upload or download files that contain software or other
                  material protected by intellectual property laws or other
                  laws, unless you own or control the rights, titles, or
                  interests thereto or have received all necessary consents or
                  rights.
                </li>
                <li>
                  Upload files that contain viruses, corrupted files, or any
                  other similar software or programs that may damage the
                  operation of another’s computer.
                </li>
                <li>
                  Use any Website to make available unsolicited advertising or
                  promotional materials, spam, pyramid schemes, chain letters,
                  or similar forms of unauthorized advertising or solicitation.
                </li>
                <li>
                  Harvest or otherwise collect information about others,
                  including email addresses, without their consent.
                </li>
                <li>
                  Falsify or delete any author attributions, legal or other
                  notices, or proprietary designations or labels of origin or
                  source.
                </li>
                <li>
                  Engage in any other action that, in the judgment of
                  Direct4.me, exposes it or any third party to potential
                  liability or detriment of any type.
                </li>
              </ol>

              <p align="center">&nbsp;</p>

              <p>
                Direct4.me will have the right to investigate and prosecute
                violations of any of the above, including intellectual property
                rights infringement and Service security issues, to the fullest
                extent of the law. Direct4.me may involve and cooperate with law
                enforcement authorities in prosecuting users who violate this
                Agreement. You acknowledge that Direct4.me has no obligation to
                monitor your access to or use of the Service or to review or
                edit any User Content, but has the right to do so for the
                purpose of operating the Service, to ensure your compliance with
                this Agreement, or to comply with applicable law or the order or
                requirement of a court, administrative agency or other
                governmental body. Direct4.me reserves the right, at any time
                and without prior notice, to remove or disable access to any
                content, including any User Content, that Direct4.me, in its
                sole discretion, considers to be in violation of this Agreement
                or otherwise harmful to the Service.
              </p>

              <p align="center">&nbsp;</p>

              <h1>LINKS</h1>

              <p>
                Links to Other Websites and Search Results: The Website may
                contain links to websites operated by other parties. The Website
                provides these links to other websites as a convenience, and
                your use of these sites is at your own risk. The linked sites
                are not under the control of Direct4.me which is not responsible
                for the content available on third party sites. Such links do
                not imply endorsement of information or material on any other
                site and Direct4.me disclaims all liability with regard to your
                access to, use of or transactions with such linked websites. You
                acknowledge and agree that Direct4.me shall not be responsible
                or liable, directly or indirectly, for any damage, loss or other
                claim caused or alleged to be caused by or in connection with,
                access to, use of or reliance on any content available on or
                through any other site or resource.
              </p>

              <p align="center">&nbsp;</p>

              <h1>MODIFICATION TO THE WEBSITE</h1>

              <p>
                Direct4.me reserves the right at any time and from time to time
                to modify, suspend, or discontinue, temporarily or permanently,
                the Website, or any portion thereof, with or without notice. You
                agree that Direct4.me will not be liable to you or to any third
                party for any modification, suspension, or discontinuance of any
                Website.
              </p>

              <p>&nbsp;</p>

              <h1>SUSPENSION AND TERMINATION RIGHTS</h1>

              <p>
                Direct4.me reserves the right, at its sole discretion,
                immediately and without notice, to suspend or terminate your
                access to the Website or any part thereof for reasons of any
                breach by you of these Terms. You agree that Direct4.me shall
                not be liable to you or any third party for any such suspension
                or termination.
              </p>

              <p>&nbsp;</p>

              <h1>DISCLAIMER</h1>

              <p>
                THE WEBSITE AND CONTENT AND THE INFORMATION, SERVICES, PRODUCTS,
                SWEEPSTAKES, CONTESTS, DRAWINGS, OR OTHER ACTIVITIES OFFERED,
                CONTAINED IN OR ADVERTISED ON THE WEBSITE, INCLUDING WITHOUT
                LIMITATION TEXT, VIDEO, GRAPHICS AND LINKS, ARE PROVIDED ON AN
                “AS IS” AND “AS AVAILABLE” BASIS WITHOUT WARRANTIES OF ANY KIND,
                WHETHER EXPRESS OR IMPLIED. TO THE MAXIMUM EXTENT PERMITTED BY
                LAW, DIRECT4.ME AND ITS LICENSORS, SUPPLIERS AND RELATED PARTIES
                DISCLAIM ALL REPRESENTATIONS AND WARRANTIES, EXPRESS OR IMPLIED,
                WITH RESPECT TO SUCH INFORMATION, SERVICES, PRODUCTS AND
                MATERIALS, INCLUDING, BUT NOT LIMITED TO, WARRANTIES OF
                MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE, TITLE,
                NON-INFRINGEMENT, FREEDOM FROM COMPUTER VIRUS AND IMPLIED
                WARRANTIES ARISING FROM COURSE OF DEALING OR COURSE OF
                PERFORMANCE. YOUR USE OF THE WEBSITE AND ANY CONTENT IS ENTIRELY
                AT YOUR OWN RISK.
              </p>

              <p>
                <br />
                Without limiting the foregoing, you are responsible for taking
                all necessary precautions to insure, that any Content or access
                to the Website is free of viruses or other harmful code.
              </p>

              <p>&nbsp;</p>

              <h1>LIMITATION ON LIABILITY</h1>

              <p>
                TO THE MAXIMUM EXTENT PERMITTED BY LAW, DIRECT4.ME AND ITS
                RELATED PARTIES DISCLAIM ALL LIABILITY, WHETHER BASED IN
                CONTRACT, TORT (INCLUDING WITHOUT LIMITATION NEGLIGENCE), STRICT
                LIABILITY OR ANY OTHER THEORY ARISING OUT OF OR IN CONNECTION
                WITH THE WEBSITE, USE, INABILITY TO USE OR PERFORMANCE OF THE
                INFORMATION, CONTENT, SERVICES, PRODUCTS AND MATERIALS AVAILABLE
                FROM OR THROUGH THE WEBSITE. IN NO EVENT SHALL DIRECT4.ME OR ANY
                OF ITS LICENSORS, SUPPLIERS OR RELATED PARTIES BE LIABLE FOR ANY
                DIRECT, INDIRECT, SPECIAL, PUNITIVE, INCIDENTAL, EXEMPLARY OR
                CONSEQUENTIAL DAMAGES, EVEN IF THESE ENTITIES HAVE BEEN
                PREVIOUSLY ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. THESE
                LIMITATIONS SHALL APPLY NOTWITHSTANDING ANY FAILURE OF ESSENTIAL
                PURPOSE OR THE EXISTENCE OF ANY LIMITED REMEDY. WITHOUT LIMITING
                THE FOREGOING, THE MAXIMUM AGGREGATE LIABILITY OF DIRECT4.ME
                ARISING OUT OF OR IN CONNECTION WITH THESE TERMS OR THE WEBSITE
                OR THE CONTENT, INFORMATION, MATERIALS, PRODUCTS OR SERVICES ON
                OR THROUGH THE WEBSITE SHALL NOT EXCEED FIFTY (50) EURO.
              </p>

              <p>
                Exclusions and Limitations: Because some jurisdictions do not
                allow limitations on how long an implied warranty lasts, or the
                exclusion or limitation of liability for consequential or
                incidental damages, the above limitations may not apply to you.
                This Limitation of Liability shall be to the maximum extent
                permitted by applicable law.
              </p>

              <p>&nbsp;</p>

              <h1>
                CHOICE OF LAW, PLACE OF PERFORMANCE, PLACE OF JURISDICTION
              </h1>

              <ol>
                <li>
                  The Law of Republic of Slovenia applies. For consumers, this
                  choice of law applies only insofar as this does not remove the
                  protection afforded by mandatory provisions of the law of the
                  state of the consumer's habitual residence (favorable
                  principle).
                </li>
                <li>
                  Place of performance for all services from our existing
                  business relationships and jurisdiction is our headquarters,
                  as far as you are not a consumer, but a merchant, a legal
                  entity under public law or public special assets. The same
                  applies if you do not have a general place of jurisdiction in
                  Slovenia or the EU or your domicile or habitual residence is
                  not known at the time the complaint is filed. The right to
                  appeal to the court at another statutory place of jurisdiction
                  remains unaffected.
                </li>
                <li>
                  The provisions of the UN Sales Convention explicitly do not
                  apply.
                </li>
              </ol>

              <p>
                Alternative Dispute Resolution: The European Commission provides
                a platform for out-of-court online consumer dispute resolution
                (EU Directive 524/2013), available at{" "}
                <a href="https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home.chooseLanguage">
                  https://ec.europa.eu
                </a>
              </p>

              <p>&nbsp;</p>

              <h1>FORCE MAJEURE</h1>

              <p>
                Direct4.me shall not be liable for any delay or failure to
                perform resulting from causes outside its reasonable control or
                unforeseen circumstances such as acts of nature or God, fire,
                flood, earthquake, accidents, strikes, war, terrorism,
                governmental act, failure of or interruption in common carriers
                (including without limitation Internet service providers and web
                hosting providers) or utilities, or shortages of transportation
                facilities, fuel, energy, labor or materials.
              </p>

              <p>&nbsp;</p>

              <h1>MISCELLANEOUS</h1>

              <p>
                These Terms and the Privacy Policy set forth the entire
                understanding and agreement between you and Direct4.me with
                respect to the subject matter hereof. If any provision of the
                Terms or the Privacy Policy is found by a court of competent
                jurisdiction to be invalid, the parties nevertheless agree that
                the court should endeavor to give effect to the parties’
                intentions as reflected in the provision, and the other
                provisions of the Terms or the Privacy Policy shall remain in
                full force and effect. Headings are for reference only and in no
                way define, limit, construe or describe the scope or extent of
                such section. Direct4.me’s failure to act with respect to any
                failure by you or others to comply with these Terms or the
                Privacy Policy does not waive its right to act with respect to
                subsequent or similar failures. You may not assign or transfer
                these Terms or the Privacy Policy or your rights or obligations
                under these Terms or the Privacy Policy without the prior
                written consent of Direct4.me, and any assignment or transfer in
                violation of this provision shall be null and void. There are no
                third- party beneficiaries to these Terms or the Privacy Policy.
              </p>

              <p>&nbsp;</p>

              <h1>QUESTIONS</h1>

              <p>
                Please direct any questions you may have about these Terms,
                technical questions or problems with the Website or the
                Services, or comments or suggestions to Direct4.me at{" "}
                <a href="mailto:info@direct4.me">info@direct4.me</a>
              </p>
            </BodyWrapper>
          </ContentWrapper>
          <Footer />
        </InteriorWrapper>
        {/* End of markup section. */}
      </Fragment>
    </ThemeProvider>
  );
};
